export { Fire as default } from './Fire';
